/**
 * BadgeService handles page title and favicon badge updates
 * Migrated from Chrome Extension badge functionality
 * (chrome.action.setBadgeText & chrome.action.setTitle)
 */
class BadgeService {
  static updatePageTitle(count, tooltip = '') {
    const baseTitle = 'Rappi Aliados';

    if (count > 0) {
      document.title = `(${count}) ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }
  }

  static updateFaviconBadge(count) {
    if (count <= 0) {
      // Reset to original favicon
      this.resetFavicon();
      return;
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 32;
    canvas.height = 32;

    // Load original favicon
    const img = new Image();
    img.onload = () => {
      try {
        // Draw base favicon
        ctx.drawImage(img, 0, 0, 32, 32);

        // Draw red badge circle
        ctx.fillStyle = '#FF0000';
        ctx.beginPath();
        ctx.arc(24, 8, 8, 0, 2 * Math.PI);
        ctx.fill();

        // Draw white text
        ctx.fillStyle = '#FFFFFF';
        ctx.font = 'bold 10px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const text = count > 99 ? '99+' : count.toString();
        ctx.fillText(text, 24, 8);

        // Update favicon
        this.setFavicon(canvas.toDataURL());
      } catch (error) {
        console.warn('Failed to update favicon badge:', error);
        this.resetFavicon();
      }
    };

    img.onerror = () => {
      console.warn('Failed to load base favicon');
      this.resetFavicon();
    };

    // Load the base favicon
    img.src = '/favicon.ico';
  }

  static setFavicon(dataUrl) {
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = dataUrl;
  }

  static resetFavicon() {
    this.setFavicon('/favicon.ico');
  }

  /**
   * Main update method - replaces extension badge functionality
   * @param {number} count - Order count to display
   * @param {string} tooltip - Tooltip text (used for page title)
   */
  static updateBadge(count, tooltip = '') {
    this.updatePageTitle(count, tooltip);
    this.updateFaviconBadge(count);
  }
}

export default BadgeService;
